import { render, staticRenderFns } from "./moocAppraise.vue?vue&type=template&id=84f12ed6&scoped=true&"
import script from "./moocAppraise.vue?vue&type=script&lang=js&"
export * from "./moocAppraise.vue?vue&type=script&lang=js&"
import style0 from "./moocAppraise.vue?vue&type=style&index=0&id=84f12ed6&scoped=true&lang=css&"
import style1 from "./moocAppraise.vue?vue&type=style&index=1&id=84f12ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f12ed6",
  null
  
)

export default component.exports